(function($, window, document) {
  var store = function (sParam) {
     var sPageURL = window.location.search.substring(1);
     var sURLVariables = sPageURL.split('&');
     for (var i = 0; i < sURLVariables.length; i++) {
       var sParameterName = sURLVariables[i].split('=');
       if (sParameterName[0] == sParam) {
         return sParameterName[1];
       }
     }     
     return '';
   };   
  
  $(function() {
    $.get("/cart.json", function(current) {
     var lg = store('store');
     var code = '';      
      
     switch(lg) { 
       case 'en-us': code = 'ly9297'; break;             
       case 'es-mx': code = 'ly9298'; break;             
       case 'pt-br': code = 'ly13726'; break;    
       case 'tr-tr': code = 'ly14456'; break;    
       case 'nl-nl': code = 'ly14000'; break;           
       case 'de-de': code = 'ly53843'; break;
     }
      
     if (code != '' && code != current.attributes.language) {       
       $.ajax({
         type: 'POST',
         dataType: 'json',
         url: '/cart/update.js',
         data: { 'attributes' : { 'language': code } },
         success: function (data) { window.location = window.location.pathname; },
         error: function(jqXHR, textStatus, errorThrown) {        
           console.log("Error, status = " + textStatus + ", " + "error thrown: " + errorThrown);  
         }
       });
     }
     else if (code != '') {window.location = window.location.pathname;}
   });
  });
 }(window.jQuery, window, document));